module.exports = __webpack_public_path__ + "img/AppIntro_d2bk.1652f079.png";